import React from 'react';
import styled from 'styled-components';
import { LoadingCommonProps, LoadingSpinner } from './';

export interface LoadingWithOverlayProps extends LoadingCommonProps {
  testId?: string;
  spinnerSize?: number;
  overlayColor?: string;
}

const LoadingWithOverlay: React.FunctionComponent<LoadingWithOverlayProps> = ({
  loading = false,
  type,
  overlayColor,
  spinnerSize,
  style,
}) => {
  const overlayBackground = overlayColor || type === 'light' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)';

  return loading ? (
    <LoadingWithOverlayContainer data-testid="loading-with-overlay" style={style}>
      <LoadingOverlay data-testid="loading-overlay" background={overlayBackground}>
        <LoadingSpinner type={type} size={spinnerSize} />
      </LoadingOverlay>
    </LoadingWithOverlayContainer>
  ) : null;
};

const LoadingWithOverlayContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`;

const LoadingOverlay = styled.div<{ background: string }>`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ background }) => background};
`;

export default LoadingWithOverlay;
